import PropTypes from "prop-types";
import React from "react";
import SettlementRequestCard from "./SettlementRequestCard";
import FullscreenLoader from "../loadings/FullscreenLoader";

function SettlementRequest(props) {
  const { data, loading} = props;

  return (
    <div className="row mt-2">
      {data?.length > 0 ? (
        data?.map((item) => (
          <div className="col-sm-6 col-lg-4 col-xl-4 d-flex" key={item.id}>
            <SettlementRequestCard data={item}/>
          </div>
        ))
      ) : (
        <div className="no-content-box d-flex flex-column justify-content-center align-items-center py-5">
          <div className="mb-3">
            <i className="fas fa-file-invoice-dollar text-muted" style={{ fontSize: '48px' }}></i>
          </div>
          <h5 className="text-muted mb-2">No Settlements Found</h5>
          {/* <p className="text-secondary mb-0">No settlement requests match your current filters</p> */}
        </div>
      )}
      {loading && <FullscreenLoader />}
    </div>
  );
}

SettlementRequest.propTypes = {
  data: PropTypes.node,
  loading: PropTypes.node,
};

export default SettlementRequest;
